import { useRef, useState } from 'react'

import { Text } from '@hhgtech/hhg-components'
import { Carousel } from '@hhgtech/hhg-components/mantine'
import { Embla } from '@mantine/carousel'
import { domainLocales } from 'domainLocales'
import { useRouterExtend } from 'hooks/useRouterExtend'
import { DEFAULT_IMG } from 'interfaces/constants'
import { useIntl } from 'react-intl'

import { RelatedArticlesProps } from '.'
import {
  StyledArticleCardWrapper,
  StyledRelatedArticleCarouselWrapper,
} from './index.styled'

export const _Desktop = ({
  title,
  articles,
  ...rest
}: RelatedArticlesProps) => {
  const { locale } = useRouterExtend()
  const { formatMessage: f } = useIntl()

  const emblaApiRef = useRef<Embla | null>(null)
  const [disablePrev, setDisablePrev] = useState(true)
  const [disableNext, setDisableNext] = useState(false)
  if (articles.length <= 2) {
    return (
      <StyledRelatedArticleCarouselWrapper {...rest}>
        <Text size="s2" type="semiBold">
          {title ||
            f({
              id: 'articlePage.relatedPostsSectionTitle',
              defaultMessage: 'Related Articles',
            })}
        </Text>
        {articles.map((article) => (
          <StyledArticleCardWrapper
            key={article.id}
            article={article}
            disabledBadge={true}
            type="author"
            size="sm"
            banner={
              <img
                src={
                  article.featureImageMobile ||
                  article.featureImage ||
                  article.featureImageMobileXs ||
                  DEFAULT_IMG
                }
                alt={article.postTitle}
                style={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'cover',
                }}
                loading="lazy"
              />
            }
            categoryLink={article.category.permalink}
            articleLink={article.permalink}
            categoryName={article.category?.displayName}
            title={article.postTitle}
            text={article.excerpt}
            styleLabel={{
              color: article.category.textColor,
            }}
            uploadTime={article.modifiedTime}
            // hasAffiliate={article.hasAffiliate}
            dataEventCategoryForTitle="Further Article"
            dataEventActionForTitle={`Article Title Click`}
            dataEventLabelForTitle={`https://${domainLocales[locale]}${article.permalink}`}
            dataEventCategoryForBanner="Further Article"
            dataEventActionForBanner={`Article Image Click`}
            dataEventLabelForBanner={`https://${domainLocales[locale]}${article.permalink}`}
            headingAs="p"
          />
        ))}
      </StyledRelatedArticleCarouselWrapper>
    )
  }
  return (
    <StyledRelatedArticleCarouselWrapper style={{ gap: '14px' }} {...rest}>
      <Text size="s2" type="semiBold">
        {title ||
          f({
            id: 'articlePage.relatedPostsSectionTitle',
            defaultMessage: 'Related Articles',
          })}
      </Text>
      {articles.length > 0 && (
        <Carousel
          slidesToShow={2.2}
          slideGap={16}
          controlSize={30}
          controlsOffset={0}
          slidesToScroll={1}
          styles={{
            root: {
              width: '100%',
            },
            controls: {
              marginLeft: -24,
              marginRight: -24,
            },
            control: {
              '&:first-child': {
                visibility: disablePrev ? 'hidden' : undefined,
                pointerEvents: disablePrev ? 'none' : undefined,
              },
              '&:last-child': {
                visibility: disableNext ? 'hidden' : undefined,
                pointerEvents: disableNext ? 'none' : undefined,
              },
            },
          }}
          getEmblaApi={(embla) => {
            emblaApiRef.current = embla
            setDisablePrev(!embla.canScrollPrev())
            setDisableNext(!embla.canScrollNext())
            embla.on('scroll', () => {
              setDisablePrev(!embla.canScrollPrev())
              setDisableNext(!embla.canScrollNext())
            })
          }}
        >
          {articles.map((article, index) => (
            <Carousel.Slide key={index}>
              <StyledArticleCardWrapper
                article={article}
                disabledBadge={true}
                type="author"
                size="sm"
                banner={
                  <img
                    src={
                      article.featureImageMobile ||
                      article.featureImage ||
                      article.featureImageMobileXs ||
                      DEFAULT_IMG
                    }
                    alt={article.postTitle}
                    style={{
                      width: '100%',
                      height: '100%',
                      objectFit: 'cover',
                    }}
                    loading="lazy"
                  />
                }
                categoryLink={article.category.permalink}
                articleLink={article.permalink}
                direction="vertical"
                categoryName={article.category?.displayName}
                title={article.postTitle}
                text={article.excerpt}
                styleLabel={{
                  color: article.category.textColor,
                }}
                uploadTime={article.modifiedTime}
                // hasAffiliate={article.hasAffiliate}
                dataEventCategoryForTitle="Further Article"
                dataEventActionForTitle={`Article Title Click`}
                dataEventLabelForTitle={`https://${domainLocales[locale]}${article.permalink}`}
                dataEventCategoryForBanner="Further Article"
                dataEventActionForBanner={`Article Image Click`}
                dataEventLabelForBanner={`https://${domainLocales[locale]}${article.permalink}`}
                headingAs="p"
              />
            </Carousel.Slide>
          ))}
        </Carousel>
      )}
    </StyledRelatedArticleCarouselWrapper>
  )
}
